import React from "react";
import { Box, Stack } from "@mui/material";
import { NavLink, Outlet } from "react-router-dom";
import TopBar from "../../../../../component/TopBar";
import { tokens, displayFont } from "../../../../../theme";

const TABS = [
  { label: "Legal Entities", to: "/app/organization", end: true },
  { label: "Departments", to: "/app/organization/departments" },
  { label: "Designations", to: "/app/organization/designations" },
  { label: "Roles & Permissions", to: "/app/organization/roles" },
  { label: "Structure", to: "/app/organization/org-chart" },
];

const Organization = () => {
  return (
    <Box sx={{ width: "100%", paddingBlock: "1rem" }}>
      <TopBar MainHeading={"Organisation"} />
      <Box sx={{ fontFamily: displayFont, fontSize: "1.75rem", fontWeight: 700, color: tokens.text, letterSpacing: "-0.01em", mb: "0.25rem" }}>
        Organisation
      </Box>
      <Box sx={{ fontSize: "0.875rem", color: tokens.textMuted, mb: "1.5rem" }}>
        Manage your legal entities, departments and designations.
      </Box>

      {/* Tab nav */}
      <Stack direction="row" spacing={3.5} sx={{ borderBottom: `1px solid ${tokens.border}`, mb: "1.5rem" }}>
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <Box
                sx={{
                  pb: "0.75rem",
                  fontSize: "0.875rem",
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? tokens.text : tokens.primary,
                  borderBottom: `2px solid ${isActive ? tokens.primary : "transparent"}`,
                  marginBottom: "-1px",
                }}
              >
                {t.label}
              </Box>
            )}
          </NavLink>
        ))}
      </Stack>

      <Outlet />
    </Box>
  );
};

export default Organization;
